export const vehicleSlides = [
  {
    tag: 'PREMIUM SEAT',
    title: '2026년 최신형 독립 릴렉션 시트',
    desc: '스타리아 라운지 2열 최고급 독립 시트로\n이동 시간도 편안한 휴식이 됩니다',
  },
  {
    tag: 'SPACIOUS TRUNK',
    title: '넉넉한 트렁크 공간',
    desc: '캐리어 4개 이상 수납 가능한 넓은 트렁크로\n공항 이동이 편리합니다',
  },
];

// 라벨은 렌더 시점 t(labelKey)로 번역. 외부 브랜드명(PayPal)은 번역 불필요하므로 고정.
// 2026-05-15: KG이니시스 간편결제(EasyPay) 가맹 계약 취소 — simple 옵션 제거.
// 2026-06-09: KG이니시스 간편결제(지불수단추가) 재가맹 완료 — simple 옵션 복원.
// 2026-06-10: 단일 'simple'(통합창, easyPayProvider 미지정)이 INICIS V2 에서 400 Bad Request
//   → 간편결제사 5종(카카오·네이버·토스·애플·삼성)을 각각 easyPayProvider 로 명시 호출.
//   UI: 결제수단엔 '간편결제' 하나만 노출하고, 결제 버튼 클릭 시 EasyPayProviderModal 에서
//   5종을 선택 → 선택한 provider id 로 EASY_PAY 호출. id↔provider 매핑은 portone.js resolveChannel.
//   (PortOne 콘솔 KG이니시스 채널 + MID 계약에 해당 간편결제사가 활성화돼 있어야 실결제 성공)
export const paymentMethods = [
  { id: 'card', labelKey: 'payment.method_card' },
  { id: 'simple', labelKey: 'payment.method_simple' },
  { id: 'bank', labelKey: 'payment.method_bank' },
  { id: 'paypal', labelKey: 'payment.method_paypal' },
];

// 'simple'(간편결제) 선택 후 결제 시 모달에 노출되는 간편결제사 5종.
export const easyPayProviders = [
  { id: 'simple_kakao',   labelKey: 'payment.method_kakao' },
  { id: 'simple_naver',   labelKey: 'payment.method_naver' },
  { id: 'simple_toss',    labelKey: 'payment.method_toss' },
  { id: 'simple_apple',   labelKey: 'payment.method_apple' },
  { id: 'simple_samsung', labelKey: 'payment.method_samsung' },
];

// 예약 내역은 별도 라우트(/reservation)지만 마이페이지 탭에 포함해 발견성·일관성 확보
// (대기 등록 내역은 /mypage/account 하단에 있는데 정작 본 예약 내역은 탭에 없던 UX 갭 보완).
export const myPageTabs = [
  { id: 'reservation', labelKey: 'mypage.tab_reservation' },
  { id: 'account', labelKey: 'mypage.tab_account' },
  { id: 'reviews', labelKey: 'mypage.tab_reviews' },
];

export const reservationTabs = [
  { id: 'all', labelKey: 'reservation.tab_all' },
  { id: 'upcoming', labelKey: 'reservation.tab_upcoming' },
  { id: 'completed', labelKey: 'reservation.tab_completed' },
  { id: 'refunded', labelKey: 'reservation.tab_refunded' },
];

export const petTypeOptions = [
  { value: 'dog-small', label: '소형견' },
  { value: 'dog-medium', label: '중형견' },
  { value: 'dog-large', label: '대형견' },
  { value: 'cat', label: '고양이' },
  { value: 'other', label: '기타' },
];

// 가상계좌 환불 은행 — value = PortOne V2 Bank enum (refundAccount.bank 에 그대로 전송).
// 자유텍스트("카카오")로 보내면 PortOne 이 'illegal discriminator' 로 거부하므로 enum 코드 사용.
export const vbankBanks = [
  { value: 'KAKAO', label: '카카오뱅크' },
  { value: 'TOSS', label: '토스뱅크' },
  { value: 'KOOKMIN', label: 'KB국민은행' },
  { value: 'SHINHAN', label: '신한은행' },
  { value: 'WOORI', label: '우리은행' },
  { value: 'HANA', label: '하나은행' },
  { value: 'NONGHYUP', label: 'NH농협은행' },
  { value: 'IBK', label: 'IBK기업은행' },
  { value: 'K_BANK', label: '케이뱅크' },
  { value: 'SC_FIRST_BANK', label: 'SC제일은행' },
  { value: 'CITI', label: '한국씨티은행' },
  { value: 'KDB', label: 'KDB산업은행' },
  { value: 'SUHYUP', label: 'Sh수협은행' },
  { value: 'POST', label: '우체국' },
  { value: 'KFCC', label: '새마을금고' },
  { value: 'SHINHYUP', label: '신협' },
  { value: 'SAVINGS_BANK', label: '저축은행' },
  { value: 'DAEGU', label: 'iM뱅크(대구)' },
  { value: 'BUSAN', label: '부산은행' },
  { value: 'KWANGJU', label: '광주은행' },
  { value: 'KYONGNAM', label: '경남은행' },
  { value: 'JEONBUK', label: '전북은행' },
  { value: 'JEJU', label: '제주은행' },
];
